var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex" }, [
    _vm.cash !== null
      ? _c("div", { staticClass: "flex items-center" }, [
          _c(
            "i",
            {
              staticClass: "tooltip mdi mdi-cash text-xl mr-1 settings-icon",
              class: _vm.cash ? "enabled" : "disabled"
            },
            [
              _c("span", { staticClass: "tooltip-text text-sm" }, [
                _vm._v(_vm._s(_vm.getTooltip("cash")))
              ])
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.card !== null
      ? _c("div", { staticClass: "flex items-center text-grey" }, [
          _c(
            "i",
            {
              staticClass:
                "tooltip mdi mdi-credit-card text-xl mr-1 settings-icon",
              class: _vm.card ? "enabled" : "disabled"
            },
            [
              _c("span", { staticClass: "tooltip-text text-sm" }, [
                _vm._v(_vm._s(_vm.getTooltip("card")))
              ])
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.accessible !== null
      ? _c("div", { staticClass: "flex items-center text-grey" }, [
          _c(
            "i",
            {
              staticClass:
                "tooltip mdi mdi-wheelchair-accessibility text-xl mr-1 settings-icon",
              class: _vm.accessible ? "enabled" : "disabled"
            },
            [
              _c("span", { staticClass: "tooltip-text text-sm" }, [
                _vm._v(_vm._s(_vm.getTooltip("accessible")))
              ])
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25f055ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25f055ce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Patient/OfficeSettings.vue
// module id = 586
// module chunks = 1